import script from "./MDataTableV2.vue?vue&type=script&setup=true&lang=js"
export * from "./MDataTableV2.vue?vue&type=script&setup=true&lang=js"

import "./MDataTableV2.vue?vue&type=style&index=0&id=dce48756&lang=scss"

const __exports__ = script;

export default __exports__